var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 12
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12 20.4 8.4-5.4L12 9.6z"
})));
export default SvgPlayButton;